import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import aa from 'search-insights';
import React__default, { useEffect } from 'react';
import { ALGOLIA_CLIENT, ALGOLIA_APP_ID } from '../../util/algolia.js';
import { useSearchContext } from '../../searchContext/SearchContextProvider.js';
import { ANALYTICS_RESULT_CLASS, ANALYTICS_WRAPPER_CLASS, ANALYTICS_SECTION_CLASS } from '../../util/analyticsConstants.js';
import { getQueryParam } from '../../util/queryString.js';

var _excluded = ["children", "resultId", "result", "className"];
var algoliaUserToken;
try {
  aa('init', {
    appId: ALGOLIA_APP_ID,
    apiKey: ALGOLIA_CLIENT,
    useCookie: true //sets an automatic user token (browser session level) so that events will be sent
  });
  aa('getUserToken', null, function (err, token) {
    if (err) {
      console.log('error getting Algolia user token');
      return;
    }
    algoliaUserToken = token;
  });
  aa('onUserTokenChange', function (token) {
    algoliaUserToken = token;
  }, {
    immediate: true
  });
} catch (_unused) {}
var SearchResultAnalyticsWrapper = function SearchResultAnalyticsWrapper(_ref) {
  var children = _ref.children,
    resultId = _ref.resultId,
    result = _ref.result,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useSearchContext = useSearchContext(),
    query = _useSearchContext.query,
    userAbTests = _useSearchContext.userAbTests,
    fireImpression = _useSearchContext.fireImpression;
  useEffect(function () {
    if (result !== null && result !== void 0 && result.showInAbTests) {
      result.showInAbTests.forEach(function (test) {
        if (test != 'none') {
          var testToFire = userAbTests.find(function (userTest) {
            return test.startsWith(userTest.Experiment);
          });
          if (testToFire) {
            fireImpression(testToFire);
          }
        }
      });
    }
    if (result !== null && result !== void 0 && result.hideInAbTests) {
      result.hideInAbTests.forEach(function (test) {
        if (test != 'none') {
          var testToFire = userAbTests.find(function (userTest) {
            return test.startsWith(userTest.Experiment);
          });
          if (testToFire) {
            fireImpression(testToFire);
          }
        }
      });
    }
  }, [result, fireImpression, userAbTests]);
  var getTrackingData = function getTrackingData(evt) {
    var _document$querySelect, _link$attributes$href, _link$attributes$href2, _result$algoliaResult, _result$algoliaResult2, _result$algoliaResult3;
    var link = evt.target.closest('a');
    var appRoot = evt.currentTarget.closest(".".concat(ANALYTICS_WRAPPER_CLASS));
    var application = appRoot.dataset.searchApplicationName;

    //Array.from rather than a spread operator is required for optimal behavior such as allowing operations such as indexOf to succeed
    var sections = Array.from(appRoot.getElementsByClassName(ANALYTICS_SECTION_CLASS)).filter(function (section) {
      var containedResults = Array.from(section.getElementsByClassName(ANALYTICS_RESULT_CLASS));
      //Only count sections that directly contain results
      return containedResults.length > 0 && containedResults.some(function (containedResult) {
        return containedResult.closest(".".concat(ANALYTICS_SECTION_CLASS)) === section;
      });
    });
    var currentSection = evt.currentTarget.closest(".".concat(ANALYTICS_SECTION_CLASS));
    var sectionPosition = Array.from(sections).indexOf(currentSection);
    var sectionName = currentSection.dataset.searchAnalyticsSectionName;
    var listSectionId = currentSection.dataset.searchAnalyticsListName;
    var results = appRoot.getElementsByClassName(ANALYTICS_RESULT_CLASS);
    var resultPosition = Array.from(results).indexOf(evt.currentTarget);
    var sectionResults = currentSection.getElementsByClassName(ANALYTICS_RESULT_CLASS);
    var sectionResultPosition = Array.from(sectionResults).indexOf(evt.currentTarget);
    var pageName = (_document$querySelect = document.querySelector('meta[name="pageName"]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.content;
    return {
      category: 'Internal Search',
      query: query,
      sectionName: sectionName,
      sectionPosition: sectionPosition,
      resultPosition: resultPosition,
      resultDestination: link === null || link === void 0 || (_link$attributes$href = link.attributes.href) === null || _link$attributes$href === void 0 ? void 0 : _link$attributes$href.nodeValue,
      resultIndex: result === null || result === void 0 ? void 0 : result.resultSource,
      resultId: resultId,
      application: application,
      location: window.location.pathname,
      label: query,
      searchTerm: query,
      eventDetail: "".concat(pageName || window.location.pathname, ";").concat(link === null || link === void 0 || (_link$attributes$href2 = link.attributes.href) === null || _link$attributes$href2 === void 0 ? void 0 : _link$attributes$href2.nodeValue, ";").concat(results.length, ";").concat(resultPosition + 1, ";").concat(sectionPosition + 1, ";").concat(sectionResultPosition + 1),
      product_id: result !== null && result !== void 0 && result.pricingProductId ? result.objectID : '',
      name: result !== null && result !== void 0 && result.pricingProductId ? result.title : '',
      core_product_id: (result === null || result === void 0 ? void 0 : result.pricingProductId) || '',
      product_version: result !== null && result !== void 0 && result.pricingProductId ? "".concat(result.productVersion) : '',
      position: sectionResultPosition + 1,
      list_section_id: listSectionId,
      algoliaUserToken: algoliaUserToken,
      algoliaQueryId: result === null || result === void 0 || (_result$algoliaResult = result.algoliaResult) === null || _result$algoliaResult === void 0 ? void 0 : _result$algoliaResult.queryId,
      //expected to be undefined for non-algolia results
      algoliaIndexPosition: result === null || result === void 0 || (_result$algoliaResult2 = result.algoliaResult) === null || _result$algoliaResult2 === void 0 ? void 0 : _result$algoliaResult2.searchPosition,
      //expected to be undefined for non-algolia results
      routingEligible: !!getQueryParam('reroutedSearch'),
      hasTypo: (result === null || result === void 0 || (_result$algoliaResult3 = result.algoliaResult) === null || _result$algoliaResult3 === void 0 || (_result$algoliaResult3 = _result$algoliaResult3.rankingInfo) === null || _result$algoliaResult3 === void 0 ? void 0 : _result$algoliaResult3.nbTypos) > 0
    };
  };
  var onClick = function onClick(evt) {
    var trackingEvent = getTrackingData(evt);
    if (window.tracking) {
      window.tracking.track('Search Result Clicked', trackingEvent);
    }
    if (result !== null && result !== void 0 && result.algoliaResult) {
      try {
        aa('clickedObjectIDsAfterSearch', {
          eventName: "Search Result Clicked - ".concat(trackingEvent.application),
          index: result.algoliaResult.indexName,
          queryID: result.algoliaResult.queryId,
          objectIDs: [result.objectID],
          positions: [result.algoliaResult.searchPosition]
        });
      } catch (ex) {
        console.log('Failed to send search insights event');
      }
    }
  };
  var alreadyFiredRightClick = false;
  //Can't detect new tab from right click menu, but we can detect that the menu was opened
  var onRightClick = function onRightClick(evt) {
    if (window.tracking && !alreadyFiredRightClick) {
      var trackingEvent = getTrackingData(evt);
      window.tracking.track('Search Result Right-Clicked', trackingEvent);
      alreadyFiredRightClick = true;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", _extends({}, otherProps, {
    className: "".concat(ANALYTICS_RESULT_CLASS, " ").concat(className),
    "data-result-id": (result === null || result === void 0 ? void 0 : result.id) || resultId,
    onClick: onClick,
    onContextMenu: onRightClick,
    onAuxClick: onRightClick
  }), children);
};

export { SearchResultAnalyticsWrapper as default };
//# sourceMappingURL=SearchResultAnalyticsWrapper.js.map
